// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"429":"01b65d0d","541":"e1b24e6b","811":"6397296f","867":"a2d2273b"}[chunkId] + ".js";
};